<template>
    <footer v-if="visible" class="site-disclaimer" role="contentinfo">
        <div class="site-disclaimer__inner">
            <h2 class="site-disclaimer__title">免责声明</h2>
            <ul class="site-disclaimer__list">
                <li>
                    本站为商业运营的网络服务平台，提供会员、付费内容及其他线上服务；具体服务内容、价格、期限和使用规则以购买页面及相关协议的实际展示为准。
                </li>
                <li>
                    站内视频、音乐、图片、文字等内容由本站、用户或第三方提供或授权，相关权利归相应权利人所有。未经许可，任何人不得擅自复制、传播或用于其他用途。
                </li>
                <li>
                    如您认为本站内容侵犯合法权益，请通过站内反馈或管理员渠道联系我们，并提供权利证明及侵权内容位置；我们核实后将依法处理。
                </li>
                <li>
                    用户上传、投稿或发布内容，应确保已取得必要权利或授权，不得侵犯他人合法权益；相关责任依法由责任方承担。
                </li>
                <li>
                    本站会尽力维护服务稳定；因系统维护、网络故障或不可抗力导致服务中断或数据异常的，按照适用法律及相关协议处理。
                </li>
            </ul>
            <p class="site-disclaimer__copy">
                &copy; {{ year }} 阿华视频网 · 商业运营服务平台
            </p>
        </div>
    </footer>
</template>

<script>
export default {
    name: "DisclaimerFooter",
    data() {
        return {
            year: new Date().getFullYear(),
        };
    },
    computed: {
        visible() {
            const path = this.$route?.path || "";
            return !path.startsWith("/platform");
        },
    },
};
</script>

<style scoped>
.site-disclaimer {
    margin-top: 0;
    padding: 24px 16px 36px;
    background: #f6f7f9;
    border-top: 1px solid #e8eaef;
}

.site-disclaimer__inner {
    max-width: 1280px;
    margin: 0 auto;
}

.site-disclaimer__title {
    margin: 0 0 12px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: var(--text2, #61666d);
    text-align: center;
}

.site-disclaimer__list {
    margin: 0;
    padding: 0;
    list-style: none;
}

.site-disclaimer__list li {
    position: relative;
    margin: 0 0 8px;
    padding-left: 14px;
    font-size: 12px;
    line-height: 20px;
    color: var(--text3, #9499a0);
    text-align: justify;
}

.site-disclaimer__list li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 8px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: var(--brand_pink, #fb7299);
    opacity: 0.65;
}

.site-disclaimer__list li:last-child {
    margin-bottom: 0;
}

.site-disclaimer__copy {
    margin: 16px 0 0;
    font-size: 12px;
    line-height: 18px;
    color: var(--text3, #9499a0);
    text-align: center;
}

@media (max-width: 768px) {
    .site-disclaimer {
        margin-top: 0;
        padding: 20px 12px 30px;
    }

    .site-disclaimer__list li {
        font-size: 11px;
        line-height: 18px;
    }
}
</style>
